// extracted by mini-css-extract-plugin
module.exports = {"links":"Links_links__zRS5j","vertical":"Links_vertical__yi5cr","link":"Links_link__eo83e"};